import { splitCamelCase } from "./splitCamelCase";

export type ValueMapper<T1, T2> = (value: T1) => T2;

export const versionMapper: ValueMapper<string | undefined, string> = (val) => val === "0.0.0" ? "[All]" : (val ?? "");
export const enumMapper: ValueMapper<string | undefined, string> = (val) => val !== undefined ? splitCamelCase(val) : "";
export const intMapper: ValueMapper<number | undefined, string> = (val) => val !== undefined ? val.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : "";
export const plainTextMapper: ValueMapper<unknown | undefined, string> = (val) => val !== undefined ? String(val) : "";